import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Divider,
  Link,
  Grid2,
  Chip
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import BuildOutlinedIcon from "@mui/icons-material/BuildOutlined";
import { axiosClient } from "../api/proxy/AxiosClient";

const APP_INFO = {
  name: "K2E",
  version: "0.10.0",
  status: "Closed Beta",
  author: "Artem Nikeienko",
  owner: "K2E",
  linkedin: "https://www.linkedin.com/in/artem-nikeienko/",
  //buildDate: new Date().toISOString()
};

const About = () => {
  
  const [usersCount, setUsersCount] = useState(null);

  useEffect(() => {
    axiosClient.get(`/users/count/`)
    .then((response) => {
      setUsersCount(response.data);
    })
    .catch((error) => {
      console.error("Error fetching users count:", error);
      setUsersCount("N/A");
    });
  }, []);

  return (
    <Box p={3}>
      <Grid2 container spacing={3} justifyContent="center">
        {/* Общая информация */}
        <Grid2>
          <Card>
            <CardContent>
              <Box display="flex" alignItems="center" gap={1} mb={1}>
                <InfoOutlinedIcon />
                <Typography variant="h6">About application</Typography>
              </Box>

              <Divider sx={{ mb: 2 }} />

              <Typography variant="body2">
                <strong>Name:</strong> {APP_INFO.name}
              </Typography>
              <Typography variant="body2">
                <strong>Version:</strong> {APP_INFO.version}
              </Typography>

              <Box mt={1}>
                <Chip
                  label={APP_INFO.status}
                  color="warning"
                  size="small"
                />
              </Box>

              {/* <Typography variant="body2" mt={2}>
                <strong>Build date:</strong>{" "}
                {new Date(APP_INFO.buildDate).toLocaleDateString()}
              </Typography> */}
            </CardContent>
          </Card>
        </Grid2>

        {/* Автор и владелец */}
        <Grid2>
          <Card>
            <CardContent>
              <Box display="flex" alignItems="center" gap={1} mb={1}>
                <BuildOutlinedIcon />
                <Typography variant="h6">Team & ownership</Typography>
              </Box>

              <Divider sx={{ mb: 2 }} />

              <Typography variant="body2">
                <strong>Author:</strong> {APP_INFO.author}
              </Typography>

              <Typography variant="body2">
                <strong>Owner:</strong> {APP_INFO.owner}
              </Typography>

              <Typography variant="body2" mt={1}>
                <strong>LinkedIn:</strong>{" "}
                <Link
                  href={APP_INFO.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {APP_INFO.linkedin}
                </Link>
              </Typography>
            </CardContent>
          </Card>
        </Grid2>

        {/* Статистика */}
        <Grid2>
          <Card>
            <CardContent>
              <Box display="flex" alignItems="center" gap={1} mb={1}>
                <PeopleAltOutlinedIcon />
                <Typography variant="h6">Statistics</Typography>
              </Box>

              <Divider sx={{ mb: 2 }} />

              <Typography variant="body2">
                <strong>Registered users:</strong>{" "}
                {usersCount !== null ? usersCount : "Loading..."}
              </Typography>

              <Typography variant="body2" mt={1} color="text.secondary">
                Statistics may be limited during beta testing.
              </Typography>
            </CardContent>
          </Card>
        </Grid2>

        {/* Примечание */}
        <Grid2>
          <Card>
            <CardContent>
              <Typography variant="body2" color="text.secondary">
                This application is currently in closed beta testing.
                Access is limited and functionality may change without notice.
              </Typography>
            </CardContent>
          </Card>
        </Grid2>
      </Grid2>
    </Box>
  );
};

export default About;
